export default "__VITE_ASSET__3179b119__"